



























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import localStorage from '@/utility/localStorage';
import { Auth } from '@/models/auth';

@Component
export default class LeftMenu extends Vue {
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo || {};
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo || {};
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl: any) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get main_domain() {
        return APP_CONFIG.settings.main_domain;
    }

    get userAvatar() {
        if (this.userInfo && this.userInfo.userName) {
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(this.userInfo.userName)}&background=ea580c&color=fff&bold=true`;
        }
        return 'assets/images/photos/loggeduser.png';
    }

    private async created() {
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
    }

    @Watch('userInfo', { immediate: true, deep: true })
    private async getCustomersInfo(newVal: any, oldVal: any) {
        if (this.userInfo && this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private onCloseMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
    }

    private async onLogout() {
        const dataRequest: Auth = {
            username: '',
            password: '',
            FirebaseToken: localStorage.get('FCM_Token')
        };

        const result = await authService.logout(dataRequest);
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }
}
